import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { RequestrefundAction } from 'src/actions/requestrefund.action';
import { SettingAction } from 'src/actions/setting.action';

import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import numeral from 'numeral';

import { showToast } from 'src/utils/common';

import { NOTI_TYPES } from 'src/utils/constants';
import { MobidanhsachdonAction } from 'src/actions/mobidanhsachdon.action';

const CreateEditDialogTaoDon = (props) => {
    const dispatch = useDispatch();
    const { leaders, brands, info, role } = useSelector(state => state.profile)
    const [dangTaoDonLe, setDangTaoDonLe] = useState(0)
    const [chietKhauCuaBan, setChietKhauCuaBan] = useState({
        chiet_khau_smart_vi: "0",
        chiet_khau_tkc: "0",
        chiet_khau_dichvu: "0",
        chiet_khau_bunca: "0",
        chiet_khau_napho: "0",
        chiet_khau_mymobifone: "0",
        chiet_khau_gsmmobifone: "0",

        chiet_khau_smart_vi_vina: "0",
        chiet_khau_tkc_vina: "0",
        chiet_khau_dichvu_vina: "0",
        chiet_khau_bunca_vina: "0",
        chiet_khau_napho_vina: "0",
        chiet_khau_mymobifone_vina: "0",
        chiet_khau_gsmmobifone_vina: "0",

        chiet_khau_smart_vi_viettel: "0",
        chiet_khau_tkc_viettel: "0",
        chiet_khau_dichvu_viettel: "0",
        chiet_khau_bunca_viettel: "0",
        chiet_khau_napho_viettel: "0",
        chiet_khau_mymobifone_viettel: "0",
        chiet_khau_gsmmobifone_viettel: "0",
    });
    const [moduleBanTien, batTatModuleBanTienValue] = useState({});

    useEffect(() => {
        async function fetchSettingModuleBanTien() {
            const moduleBanTien_res = await dispatch(SettingAction.findByKey('bat_tat_module_ban_tien'))
            let moduleBanTien_value = JSON.parse(moduleBanTien_res.data.value);
            moduleBanTien_value = {
                topup: moduleBanTien_value.topup == '1' ? 1 : 2,
                tkc: moduleBanTien_value.tkc == '1' ? 1 : 2, 
                dv: moduleBanTien_value.dv == '1' ? 1 : 2,
                bc: moduleBanTien_value.bc == '1' ? 1 : 2,
                napho: moduleBanTien_value.napho == '1' ? 1 : 2,
                mymobifone: moduleBanTien_value.mymobifone == '1' ? 1 : 2,
                gsmmobifone: moduleBanTien_value.gsmmobifone == '1' ? 1 : 2,

                topup_vina: moduleBanTien_value.topup_vina == '1' ? 1 : 2,
                tkc_vina: moduleBanTien_value.tkc_vina == '1' ? 1 : 2, 
                dv_vina: moduleBanTien_value.dv_vina == '1' ? 1 : 2,
                bc_vina: moduleBanTien_value.bc_vina == '1' ? 1 : 2,

                topup_viettel: moduleBanTien_value.topup_viettel == '1' ? 1 : 2,
                tkc_viettel: moduleBanTien_value.tkc_viettel == '1' ? 1 : 2, 
                dv_viettel: moduleBanTien_value.dv_viettel == '1' ? 1 : 2,
                bc_viettel: moduleBanTien_value.bc_viettel == '1' ? 1 : 2,
            }
            batTatModuleBanTienValue(moduleBanTien_value)
        }
        fetchSettingModuleBanTien();
    }, [])

    useEffect(() => {
        async function fetchData() {
            if (info && info.cai_dat_chiet_khau) {
                try {
                    const jsonObject = JSON.parse(info.cai_dat_chiet_khau);
                    setChietKhauCuaBan({
                        chiet_khau_smart_vi: typeof jsonObject.chiet_khau_smart_vi !== 'undefined' ? jsonObject.chiet_khau_smart_vi : '0',
                        chiet_khau_tkc: typeof jsonObject.chiet_khau_tkc !== 'undefined' ? jsonObject.chiet_khau_tkc : '0',
                        chiet_khau_dichvu: typeof jsonObject.chiet_khau_dichvu !== 'undefined' ? jsonObject.chiet_khau_dichvu : '0',
                        chiet_khau_bunca: typeof jsonObject.chiet_khau_bunca !== 'undefined' ? jsonObject.chiet_khau_bunca : '0',
                        chiet_khau_napho: typeof jsonObject.chiet_khau_napho !== 'undefined' ? jsonObject.chiet_khau_napho : '0',
                        chiet_khau_mymobifone: typeof jsonObject.chiet_khau_mymobifone !== 'undefined' ? jsonObject.chiet_khau_mymobifone : '0',
                        chiet_khau_gsmmobifone: typeof jsonObject.chiet_khau_gsmmobifone !== 'undefined' ? jsonObject.chiet_khau_gsmmobifone : '0',

                        chiet_khau_smart_vi_vina: typeof jsonObject.chiet_khau_smart_vi_vina !== 'undefined' ? jsonObject.chiet_khau_smart_vi_vina : '0',
                        chiet_khau_tkc_vina: typeof jsonObject.chiet_khau_tkc_vina !== 'undefined' ? jsonObject.chiet_khau_tkc_vina : '0',
                        chiet_khau_dichvu_vina: typeof jsonObject.chiet_khau_dichvu_vina !== 'undefined' ? jsonObject.chiet_khau_dichvu_vina : '0',
                        chiet_khau_bunca_vina: typeof jsonObject.chiet_khau_bunca_vina !== 'undefined' ? jsonObject.chiet_khau_bunca_vina : '0',
                        chiet_khau_napho_vina: typeof jsonObject.chiet_khau_napho_vina !== 'undefined' ? jsonObject.chiet_khau_napho_vina : '0',
                        chiet_khau_mymobifone_vina: typeof jsonObject.chiet_khau_mymobifone_vina !== 'undefined' ? jsonObject.chiet_khau_mymobifone_vina : '0',
                        chiet_khau_gsmmobifone_vina: typeof jsonObject.chiet_khau_gsmmobifone_vina !== 'undefined' ? jsonObject.chiet_khau_gsmmobifone_vina : '0',

                        chiet_khau_smart_vi_viettel: typeof jsonObject.chiet_khau_smart_vi_viettel !== 'undefined' ? jsonObject.chiet_khau_smart_vi_viettel : '0',
                        chiet_khau_tkc_viettel: typeof jsonObject.chiet_khau_tkc_viettel !== 'undefined' ? jsonObject.chiet_khau_tkc_viettel : '0',
                        chiet_khau_dichvu_viettel: typeof jsonObject.chiet_khau_dichvu_viettel !== 'undefined' ? jsonObject.chiet_khau_dichvu_viettel : '0',
                        chiet_khau_bunca_viettel: typeof jsonObject.chiet_khau_bunca_viettel !== 'undefined' ? jsonObject.chiet_khau_bunca_viettel : '0',
                        chiet_khau_napho_viettel: typeof jsonObject.chiet_khau_napho_viettel !== 'undefined' ? jsonObject.chiet_khau_napho_viettel : '0',
                        chiet_khau_mymobifone_viettel: typeof jsonObject.chiet_khau_mymobifone_viettel !== 'undefined' ? jsonObject.chiet_khau_mymobifone_viettel : '0',
                        chiet_khau_gsmmobifone_viettel: typeof jsonObject.chiet_khau_gsmmobifone_viettel !== 'undefined' ? jsonObject.chiet_khau_gsmmobifone_viettel : '0',
                    });
                } catch (error) {
                    console.log(error);
                }
            }
        }
        fetchData();
    }, [])
    
    const [napLeValues, setNapLeValues] = useState({
        number_type: '1',
        operator: '-99',
        ten_kh: '',
        nha_mang: 'tkc',
        boi_so: '-99',
        thue_bao: '',
        so_tien: '0',
    });

    const [napDonValues, setNapDonValues] = useState({
        number_type: '1',
        operator: '-99',
        ten_don: '',
        nha_mang: 'tkc',
        boi_so: '-99',
        chi_tiet_don: '',
        outputChiTietDon: [],
        error: false,
    });

    const resetNapLeValues = () => {
        setNapLeValues({
            number_type: '1',
            operator: '-99',
            ten_kh: '',
            nha_mang: 'tkc',
            boi_so: '-99',
            thue_bao: '',
            so_tien: '0',
        })
    }

    const resetNapDonValues = () => {
        setNapDonValues({
            number_type: '1',
            operator: '-99',
            ten_don: '',
            nha_mang: 'tkc',
            boi_so: '-99',
            chi_tiet_don: '',
            outputChiTietDon: [],
            error: false,
        })
    }

    const handleChangeNapLe = (event) => {
        if (event.target.name == 'so_tien') event.target.value = numeral(event.target.value).format('0,0')
        if (event.target.name == 'number_type' && event.target.value != '1' && napLeValues.nha_mang == 'tkc') {
            setNapLeValues({
                ...napLeValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else if (event.target.name == 'nha_mang' && event.target.value == 'tkc') {
            setNapLeValues({
                ...napLeValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else if (event.target.name == 'nha_mang' && event.target.value == 'napho') {
            setNapLeValues({
                ...napLeValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else {
            setNapLeValues({
                ...napLeValues,
                [event.target.name]: event.target.value,
            });
        }
    };

    const handleChangeNapDon = (event) => {
        if (event.target.name == 'number_type' && event.target.value != '1' && napDonValues.nha_mang == 'tkc') {
            setNapDonValues({
                ...napDonValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else if (event.target.name == 'nha_mang' && event.target.value == 'tkc') {
            setNapDonValues({
                ...napDonValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else if (event.target.name == 'nha_mang' && event.target.value == 'napho') {
            setNapDonValues({
                ...napDonValues,
                [event.target.name]: event.target.value,
                'number_type': '1',
            });
        } else {
            setNapDonValues({
                ...napDonValues,
                [event.target.name]: event.target.value,
            });
        }
    };

    const onLookupNapLe = async () => {
        let payload = napLeValues

        resetNapLeValues();

        payload.thue_bao = payload.thue_bao.trim().replace(/\D/g, '').slice(-9);
        payload.so_tien = payload.so_tien.trim().replace(/,/g, '');

        if (payload.number_type == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn loại thuê bao')
            return;
        }

        if (payload.operator == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng')
            return;
        }

        if (payload.ten_kh == '') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập tên KH')
            return;
        }

        if (payload.nha_mang == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng nạp')
            return;
        }

        // if (payload.nha_mang != 'tkc' && payload.boi_so == '-99') {
        //   showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn bội số')
        //   return;
        // }

        if (payload.thue_bao == '') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập thuê bao')
            return;
        }

        if (parseInt(payload.so_tien) == 0) {
            showToast(NOTI_TYPES.ERROR, 'Số tiền phải > 0')
            return;
        }

        if (payload.nha_mang != 'tkc' && parseInt(payload.so_tien) % 10000 != 0) {
            showToast(NOTI_TYPES.ERROR, 'Số tiền phải là bội số của 10.000')
            return;
        }

        if (role.priority > 2 && payload.nha_mang == 'tkc' && parseInt(payload.so_tien) < 10000) {
            showToast(NOTI_TYPES.ERROR, 'Yêu cầu số tiền nạp phải >= 10.000')
            return;
        }

        if (payload.nha_mang == 'smart_vi' && parseInt(payload.so_tien) < 20000) {
            showToast(NOTI_TYPES.ERROR, 'Yêu cầu số tiền nạp phải >= 20.000')
            return;
        }

        console.log(payload)

        try {
            const result = await dispatch(MobidanhsachdonAction.create({ number_type: payload.number_type, operator: payload.operator, loai_don: 'nap_le', ten_kh: payload.ten_kh, nha_mang: payload.nha_mang, boi_so: payload.boi_so, thue_bao: payload.thue_bao, so_tien: payload.so_tien }));
            if (result && result.result == 'success') {
                showToast(NOTI_TYPES.SUCCESS, 'Tạo đơn thành công!');
                props.handleClose();
            } else {
                let errorMes = `Tạo đơn thất bại!`;
                if (typeof result.msg !== 'undefined') errorMes = result.msg;
                showToast(NOTI_TYPES.ERROR, errorMes);
            }
        } catch (error) {
            let errorMes = `Tạo đơn thất bại!`;
            if (typeof error.msg !== 'undefined') errorMes = error.msg;
            showToast(NOTI_TYPES.ERROR, errorMes);
        }
    }
    
    const onLookupNapDon = async () => {
        let payload = napDonValues

        resetNapDonValues();

        if (payload.number_type == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn loại thuê bao')
            return;
        }

        if (payload.operator == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng')
            return;
        }

        if (payload.ten_don == '') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập tên đơn')
            return;
        }

        if (payload.nha_mang == '-99') {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn nhà mạng nạp')
            return;
        }

        // if (payload.nha_mang != 'tkc' && payload.boi_so == '-99') {
        //   showToast(NOTI_TYPES.ERROR, 'Bạn phải chọn bội số')
        //   return;
        // }
        
        if (!payload.error) {
            if (payload.outputChiTietDon.length == 0) {
            showToast(NOTI_TYPES.ERROR, 'Bạn phải nhập chi tiết đơn')
            return;
            }

            console.log(payload)

            try {
                const result = await dispatch(MobidanhsachdonAction.create({ number_type: payload.number_type, operator: payload.operator, loai_don: 'nap_don', ten_don: payload.ten_don, nha_mang: payload.nha_mang, boi_so: payload.boi_so, chi_tiet_don: payload.outputChiTietDon }));
                
                // if (result && result.result == 'success') showToast(NOTI_TYPES.SUCCESS, 'Tạo đơn thành công!');
                // else {
                //   let errorMes = `Tạo đơn thất bại!`;
                //   if (typeof result.msg !== 'undefined') errorMes = result.msg;
                //   showToast(NOTI_TYPES.ERROR, errorMes);
                // }

                if (result && result.result == 'failed') {
                    let errorMes = `Tạo đơn thất bại!`;
                    if (typeof result.msg !== 'undefined') errorMes = result.msg;
                    showToast(NOTI_TYPES.ERROR, errorMes);
                    return;
                }
                
                if (result && result.ket_qua_nap_nhieu_so && result.ket_qua_nap_nhieu_so.length > 0) {
                    let res = ''

                    for (let i = 0; i < result.ket_qua_nap_nhieu_so.length; i++) {
                        res += `- ${result.ket_qua_nap_nhieu_so[i].thue_bao}: ${result.ket_qua_nap_nhieu_so[i].ket_qua.result == 'success' ? 'THÀNH CÔNG' : 'THẤT BẠI'} - ${result.ket_qua_nap_nhieu_so[i].ket_qua.msg} (${result.ket_qua_nap_nhieu_so[i].ket_qua.code})\n`
                    }

                    //alert(res);
                    props.handleClose();
                }
            } catch (error) {
                let errorMes = `Tạo đơn thất bại!`;
                if (typeof error.msg !== 'undefined') errorMes = error.msg;
                showToast(NOTI_TYPES.ERROR, errorMes);
            }
        }
    }

    const handleBlur = (event) => {
        let outputChiTietDon = [];

        if (event.target.name == 'chi_tiet_don') {
            let outputCtd = '';
            let ctd = event.target.value
            ctd = ctd.split(/\n/g);
            if (ctd)
            {
                for (let i = 0; i < ctd.length; i++) {
                    let napTheoSo = ctd[i].split(/[\s,]+/);
                    if (napTheoSo && ctd[i].trim() != '') {
                        let thue_bao = napTheoSo[0].replace(/\D/g, '');
                        if (napTheoSo.length == 2) {
                            let so_tien = napTheoSo[napTheoSo.length - 1].replace(/\D/g, '');

                            if (napDonValues.nha_mang != 'tkc' && so_tien % 10000 != 0) {
                                setNapDonValues({
                                    ...napDonValues,
                                    error: true,
                                });
                                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền không phải là bội số của 10.000`)
                                return;
                            }

                            if (role.priority > 2 && napDonValues.nha_mang == 'tkc' && so_tien < 10000) {
                                setNapDonValues({
                                    ...napDonValues,
                                    error: true,
                                });
                                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền nạp phải >= 10.000`)
                                return;
                            }

                            if (napDonValues.nha_mang == 'smart_vi' && so_tien < 20000) {
                                setNapDonValues({
                                    ...napDonValues,
                                    error: true,
                                });
                                showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) số tiền nạp phải >= 20.000`)
                                return;
                            }

                            outputCtd += `${thue_bao},${so_tien}`;
                            if (i < ctd.length - 1) outputCtd += '\n'
                            outputChiTietDon.push({thue_bao: thue_bao.slice(-9), so_tien});
                        } else {
                            setNapDonValues({
                                ...napDonValues,
                                error: true,
                            });
                            showToast(NOTI_TYPES.ERROR, `Dòng thứ ${i + 1} (${thue_bao}) nhập sai cấu trúc, dấu phẩy hoặc khoảng trắng đặt sai vị trí`)
                            return;
                        }
                    }
                }
            }
            event.target.value = outputCtd;
        }
        setNapDonValues({
            ...napDonValues,
            [event.target.name]: event.target.value,
            outputChiTietDon,
            error: false,
        });
    };

    const onPressPositive = async () => {
        props.handleClose();
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            maxWidth={false}
            PaperProps={{
                style: {
                    width: 620,
                    maxWidth: "95vw",
                    borderRadius: 2,
                    overflow: "hidden"
                }
            }}
        >
            {/* HEADER */}
            <DialogTitle
                style={{
                    background: "#f3f3f3",
                    borderBottom: "1px solid #dcdcdc",
                    padding: "12px 18px",
                    fontSize: 28,
                    fontWeight: 400,
                    color: "#444"
                }}
            >
                Bắn tiền
            </DialogTitle>

            <DialogContent style={{ padding: 18 }}>

                {/* CHIẾT KHẤU */}
                {/* <div style={{ marginBottom: 15, fontSize: 14, lineHeight: "22px" }}>
                    <span style={{ color: "#0d6efd", fontWeight: "bold" }}>
                        * Chiết khấu của bạn:
                    </span>
                    <br />

                    {(role.priority < 3 ||
                        (role.priority > 2 && moduleBanTien.tkc == 1)) && (
                        <span style={{ fontWeight: "bold" }}>
                            - TKC:
                            <span style={{ fontWeight: 400 }}>
                                <span style={{ color: "green" }}> MOBI:</span>{" "}
                                {chietKhauCuaBan.chiet_khau_tkc}%,
                                <span style={{ color: "#0d6efd" }}> VINA:</span>{" "}
                                {chietKhauCuaBan.chiet_khau_tkc_vina}%,
                                <span style={{ color: "red" }}> VIETTEL:</span>{" "}
                                {chietKhauCuaBan.chiet_khau_tkc_viettel}%
                            </span>
                        </span>
                    )}
                </div> */}

                <div
                    style={{marginBottom: '25px'}}
                >
                    <span style={{color: 'blue'}}>* Chiết khấu của bạn:</span><br></br>
                    {(role.priority < 3 || role.priority > 2 && moduleBanTien.tkc == 1) && <span style={{color: 'black', fontWeight: 'bold'}}>- TKC: <span style={{color: 'black'}}><span style={{color: 'green'}}>MOBI: </span>{chietKhauCuaBan.chiet_khau_tkc} %, <span style={{color: 'blue'}}>VINA: </span>{chietKhauCuaBan.chiet_khau_tkc_vina} %, <span style={{color: 'red'}}>VIETTEL: </span>{chietKhauCuaBan.chiet_khau_tkc_viettel} %</span><br></br></span>}
                        {/* {(role.priority < 3 || role.priority > 2 && moduleBanTien.dv == 1) && <span style={{color: 'black', fontWeight: 'bold'}}>- DV: <span style={{color: 'brown'}}><span style={{color: 'green'}}>MOBI: </span>{chietKhauCuaBan.chiet_khau_dichvu} %, <span style={{color: 'blue'}}>VINA: </span>{chietKhauCuaBan.chiet_khau_dichvu_vina} %, <span style={{color: 'red'}}>VIETTEL: </span>{chietKhauCuaBan.chiet_khau_dichvu_viettel} %</span><br></br></span>} */}
                        {/* {(role.priority < 3 || role.priority > 2 && moduleBanTien.bc == 1) && <span style={{color: 'black', fontWeight: 'bold'}}>- BC: <span style={{color: 'brown'}}><span style={{color: 'green'}}>MOBI: </span>{chietKhauCuaBan.chiet_khau_bunca} %, <span style={{color: 'blue'}}>VINA: </span>{chietKhauCuaBan.chiet_khau_bunca_vina} %, <span style={{color: 'red'}}>VIETTEL: </span>{chietKhauCuaBan.chiet_khau_bunca_viettel} %</span><br></br></span>} */}
                </div>

                {/* ================== NẠP LẺ ================== */}
                <div style={{ display: dangTaoDonLe == 1 ? "block" : "none" }}>

                    {/* TÊN KH */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Tên KH *
                        </div>
                        <TextField
                            fullWidth
                            name="ten_kh"
                            value={napLeValues.ten_kh}
                            onChange={handleChangeNapLe}
                            variant="outlined"
                            size="small"
                        />
                    </div>

                    {/* NHÀ MẠNG */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Nhà mạng *
                        </div>
                        <Select1
                            fullWidth
                            size="small"
                            name="operator"
                            value={napLeValues.operator || -99}
                            onChange={handleChangeNapLe}
                        >
                            <MenuItem value="-99">Chọn nhà mạng</MenuItem>
                            <MenuItem value="MOBIFONE">MOBIFONE</MenuItem>
                            <MenuItem value="VINAPHONE">VINAPHONE</MenuItem>
                            <MenuItem value="VIETTEL">VIETTEL</MenuItem>
                        </Select1>
                    </div>

                    {/* LOẠI THUÊ BAO */}
                    {napLeValues.nha_mang != "tkc" &&
                        napLeValues.nha_mang != "napho" && (
                            <div style={{ display: "flex", marginBottom: 10 }}>
                                <div
                                    style={{
                                        width: 120,
                                        fontWeight: "bold",
                                        paddingTop: 10
                                    }}
                                >
                                    Loại TB *
                                </div>

                                <Select1
                                    fullWidth
                                    size="small"
                                    name="number_type"
                                    value={napLeValues.number_type || -99}
                                    onChange={handleChangeNapLe}
                                >
                                    <MenuItem value="-99">Chọn loại</MenuItem>
                                    <MenuItem value="1">TRẢ TRƯỚC</MenuItem>
                                    <MenuItem value="2">TRẢ SAU</MenuItem>
                                </Select1>
                            </div>
                        )}

                    {/* THUÊ BAO */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Thuê bao *
                        </div>
                        <TextField
                            fullWidth
                            name="thue_bao"
                            value={napLeValues.thue_bao}
                            onChange={handleChangeNapLe}
                            variant="outlined"
                            size="small"
                        />
                    </div>

                    {/* SỐ TIỀN */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Số tiền *
                        </div>
                        <TextField
                            fullWidth
                            name="so_tien"
                            value={napLeValues.so_tien}
                            onChange={handleChangeNapLe}
                            variant="outlined"
                            size="small"
                        />
                    </div>

                    {/* BUTTON */}
                    <div style={{ textAlign: "right", marginTop: 12 }}>
                        <Button
                            variant="contained"
                            onClick={onLookupNapLe}
                            style={{
                                background: "#d9534f",
                                color: "#fff",
                                padding: "8px 25px"
                            }}
                        >
                            Thực hiện
                        </Button>
                    </div>
                </div>

                {/* ================== NẠP LÔ ================== */}
                <div style={{ display: dangTaoDonLe == 0 ? "block" : "none" }}>

                    {/* TÊN ĐƠN */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Nhóm đơn
                        </div>

                        <TextField
                            fullWidth
                            size="small"
                            name="ten_don"
                            value={napDonValues.ten_don}
                            onChange={handleChangeNapDon}
                        />
                    </div>

                    {/* NHÀ MẠNG */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Nhà mạng *
                        </div>

                        <Select1
                            fullWidth
                            size="small"
                            name="operator"
                            value={napDonValues.operator || -99}
                            onChange={handleChangeNapDon}
                        >
                            <MenuItem value="-99">Chọn nhà mạng</MenuItem>
                            <MenuItem value="MOBIFONE">MOBIFONE</MenuItem>
                            <MenuItem value="VINAPHONE">VINAPHONE</MenuItem>
                            <MenuItem value="VIETTEL">VIETTEL</MenuItem>
                        </Select1>
                    </div>

                    {/* LOẠI TB */}
                    {napDonValues.nha_mang != "tkc" &&
                        napDonValues.nha_mang != "napho" && (
                            <div style={{ display: "flex", marginBottom: 10 }}>
                                <div
                                    style={{
                                        width: 120,
                                        fontWeight: "bold",
                                        paddingTop: 10
                                    }}
                                >
                                    Loại TB *
                                </div>

                                <Select1
                                    fullWidth
                                    size="small"
                                    name="number_type"
                                    value={napDonValues.number_type || -99}
                                    onChange={handleChangeNapDon}
                                >
                                    <MenuItem value="-99">Chọn loại</MenuItem>
                                    <MenuItem value="1">TRẢ TRƯỚC</MenuItem>
                                    <MenuItem value="2">TRẢ SAU</MenuItem>
                                </Select1>
                            </div>
                        )}

                    {/* CHI TIẾT */}
                    <div style={{ display: "flex", marginBottom: 10 }}>
                        <div style={{ width: 120, fontWeight: "bold", paddingTop: 10 }}>
                            Điện thoại *
                        </div>

                        <textarea
                            rows="6"
                            name="chi_tiet_don"
                            value={napDonValues.chi_tiet_don}
                            onChange={handleChangeNapDon}
                            onBlur={handleBlur}
                            placeholder="901111111,100000"
                            style={{
                                width: "100%",
                                border: "1px solid #ccc",
                                padding: 10,
                                fontSize: 15,
                                resize: "none"
                            }}
                        />
                    </div>

                    {/* NOTE */}
                    <div
                        style={{
                            color: "#d9534f",
                            fontSize: 14,
                            marginBottom: 12
                        }}
                    >
                        Lưu ý: nhập mỗi dòng 1 số điện thoại và số tiền.
                    </div>

                    {/* BUTTON */}
                    <div style={{ textAlign: "right" }}>
                        <Button
                            variant="contained"
                            onClick={onLookupNapDon}
                            style={{
                                background: "#d9534f",
                                color: "#fff",
                                padding: "8px 25px",
                                marginRight: 8
                            }}
                        >
                            Thực hiện
                        </Button>

                        <Button
                            onClick={props.handleClose}
                            style={{
                                background: "#e0e0e0",
                                color: "#333",
                                padding: "8px 25px"
                            }}
                        >
                            Đóng
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default CreateEditDialogTaoDon;